export const SELECT_COUNTRY = 'selected/SELECT_COUNTRY'
export const SELECT_REGION = 'selected/SELECT_REGION'
export const SELECT_LOCALITY = 'selected/SELECT_LOCALITY'
export const SELECT_AREA = 'selected/SELECT_AREA'
export const SELECT_STREET = 'selected/SELECT_STREET'
export const SELECT_HOUSE = 'selected/SELECT_HOUSE'
export const SELECT_ENTRY = 'selected/SELECT_ENTRY'
export const SELECT_FLAT = 'selected/SELECT_FLAT'
